import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiVisa, SetOfBooksContainerModel, SetOfBooksService } from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// import "rxjs-compat/add/operator/map";

@Component({
  selector: 'app-select-set-of-books-drop-down',
  templateUrl: './select-set-of-books-drop-down.component.html',
  styleUrls: ['./select-set-of-books-drop-down.component.scss']
})

export class SelectSetOfBooksDropDownComponent implements OnInit, OnDestroy {

  @Input() apiVisa: ApiVisa;
  @Input() setOfBooks = new FormControl();
  @Input() required: boolean;

  @Output() setOfBooksChange = new EventEmitter<FormControl>();
  @Output() setOfBooksSelected = new EventEmitter<SetOfBooksContainerModel>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<SetOfBooksContainerModel[]> = new ReplaySubject<SetOfBooksContainerModel[]>(1);
  setOfBooksList: SetOfBooksContainerModel[] = [];
  selectedSetOfBooks: SetOfBooksContainerModel;
  filteredSetOfBooks: any = [];

  protected _onDestroy = new Subject<void>();

  constructor(
    private setOfBooksService: SetOfBooksService
  ) {
  }

  ngOnInit() {
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterSetOfBooks();
      });

    this.getSetOfBooks();
  }

  getSetOfBooks() {
    this.setOfBooksService.get(this.apiVisa).subscribe((x: any) => {
      x.data.forEach((data) => {
        this.filteredSetOfBooks.push(data);
        this.setOfBooksList.push(data);
      });

      // sorting
      const sorted = this.setOfBooksList.sort((a, b) => (a['bl_fi_mst_set_of_books_hdr'].name < b['bl_fi_mst_set_of_books_hdr'].name ? -1 : 1));

      this.filteredOptions$.next(sorted.slice());
    });
  }

  filterSetOfBooks() {
    if (!this.filteredSetOfBooks) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.filteredSetOfBooks.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the Fiscal Year
    this.filteredOptions$.next(
      this.filteredSetOfBooks.filter((option) =>
        (option['bl_fi_mst_set_of_books_hdr'].name?
          option['bl_fi_mst_set_of_books_hdr'].name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(guid: string) {
    if (guid) {
      console.log(guid)
      this.setOfBooks.patchValue(guid);
      this.selectedSetOfBooks = this.setOfBooksList.find(fy => fy['bl_fi_mst_set_of_books_hdr'].guid === guid);
      this.setOfBooksSelected.emit(this.selectedSetOfBooks);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
